export const DOUBLE = 'double_breast';
export const SINGLE = 'single_breast';
export const TUXEDO = 'tuxedo';